
import { useState } from "react";
import { Search, Filter, Star } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ChatFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  showFavoritesOnly: boolean;
  onToggleFavorites: () => void;
}

export const ChatFilters = ({
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  showFavoritesOnly,
  onToggleFavorites,
}: ChatFiltersProps) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  const categories = [
    { value: "todas", label: "Todas" },
    { value: "residencia", label: "Residencia" },
    { value: "asilo", label: "Asilo" },
    { value: "trabajo", label: "Trabajo" },
    { value: "familia", label: "Familia" },
    { value: "otros", label: "Otros" },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4 mb-6" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
      {/* Search Bar */}
      <div className="relative mb-4">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-coolGray h-4 w-4" />
        <Input
          type="text"
          placeholder="Buscar por palabra clave..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10 border-gray-200 focus:border-primary focus:ring-primary"
        />
      </div>

      {/* Filters Row */}
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
        {/* Category Filter */}
        <div className="flex-1 min-w-0">
          <Select value={selectedCategory} onValueChange={onCategoryChange}>
            <SelectTrigger className="w-full sm:w-48">
              <SelectValue placeholder="Categoría" />
            </SelectTrigger>
            <SelectContent>
              {categories.map((category) => (
                <SelectItem key={category.value} value={category.value}>
                  {category.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Favorites Toggle */}
        <Button
          variant={showFavoritesOnly ? "default" : "outline"}
          onClick={onToggleFavorites}
          className={`flex items-center gap-2 ${
            showFavoritesOnly 
              ? "bg-primary text-white" 
              : "border-gray-200 text-coolGray hover:text-navy hover:border-gray-300"
          }`}
        >
          <Star className={`h-4 w-4 ${showFavoritesOnly ? "fill-current" : ""}`} />
          Favoritos
        </Button>
      </div>
    </div>
  );
};
